import { useAction, useAtom } from '@reatom/npm-react'
import { useMemo } from 'react'
import styled from 'styled-components'

import { Button } from '@blade/ui-kit'
import { isAdminAtom } from '@root/entities/auth'
import { environmentAtom } from '@root/shared'
import { useTranslation } from '@root/shared/localization'
import { Trash2Icon } from '@root/shared/ui-kit'

import { reatomBackOfficeCommentDeleteModel } from '../atoms/reatom-back-office-comment-delete-model'

import type { CommentId } from '@root/entities/comment/model/comment-id'

interface Props {
  commentId: CommentId
  onDone: (commentId: CommentId) => void
}
export const BackOfficeCommentDeleteButton = (props: Props) => {
  const { t } = useTranslation()
  const [isAdmin] = useAtom(isAdminAtom)
  const [environment] = useAtom(environmentAtom)

  const { deleteWithConfirmationAction, model } = useMemo(
    () =>
      reatomBackOfficeCommentDeleteModel({
        commentId: props.commentId,
        onDone: props.onDone,
      }),
    [props.commentId, props.onDone],
  )
  const [requestState] = useAtom(model)
  const deleteWithConfirmation = useAction(deleteWithConfirmationAction)

  return isAdmin || environment.isDev ? (
    <DeleteButton
      size="xxs"
      disabled={requestState.loading}
      busy={requestState.loading}
      variant="ghost"
      iconRight={<Trash2Icon />}
      onClick={() => deleteWithConfirmation()}
    >
      {t('comment.message.delete_as_admin')}
    </DeleteButton>
  ) : undefined
}

const DeleteButton = styled(Button)`
  color: var(--text-9);

  &:hover {
    background: transparent;
  }

  font-size: 11px;
  font-weight: 500;
  line-height: 16px;
  height: 20px;

  padding-inline: 2px;

  svg {
    width: 16px;
  }
`
